<label class="field" [attr.for]="textareaId">
  <span class="field-label">{{ label }} <strong *ngIf="required" aria-hidden="true">*</strong></span>
  <ion-textarea
    [id]="textareaId"
    [value]="value"
    [placeholder]="placeholder"
    [rows]="rows"
    [maxlength]="maxLength"
    [disabled]="disabled"
    [required]="required"
    [class.app-textarea--no-default-vertical-padding]="removeDefaultVerticalPadding"
    [attr.aria-label]="label"
    [attr.aria-invalid]="errorText ? 'true' : null"
    [attr.aria-describedby]="errorText ? textareaId + '-error' : null"
    (ionInput)="onInput($event)"
    (ionBlur)="onBlur()">
  </ion-textarea>
  <span class="field-meta">
    <small *ngIf="errorText" [id]="textareaId + '-error'" class="field-error">{{ errorText }}</small>
    <small *ngIf="maxLength !== null" class="field-counter">{{ value.length }} / {{ maxLength }}</small>
  </span>
</label>